// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AllPinsHeader__container-ebcc7a {
  display: flex;
  height: 73px;
  width: 100%;
  background-color: var(--base-0);
  border-bottom: 1px solid var(--base-20);
  box-shadow: var(--box-shadow-4);
  z-index: 1;
  padding-top: 4px;
  padding-bottom: 4px;
  padding-inline-start: 8px;
  padding-inline-end: 24px;
  box-sizing: border-box;
  align-items: center;
  justify-content: space-between;
  position: relative;
}

.AllPinsHeader__info-d4a9e0 {
  display: flex;
  align-items: center;
  margin-inline-start: 8px;
}

.AllPinsHeader__header-title-b4daff {
  font: var(--primary-font-family);
  font-size: 20px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0.15px;
  color: var(--base-110);
}

.AllPinsHeader__back-e72cb7 {
  margin-inline-end: 16px;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/AllPins/AllPinsHeader/AllPinsHeader.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,YAAA;EACA,WAAA;EACA,+BAAA;EACA,uCAAA;EACA,+BAAA;EACA,UAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,wBAAA;EACA,sBAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,wBAAA;AACF;;AAEA;EACE,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,sBAAA;AACF;;AAEA;EACE,uBAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  height: 73px;\n  width: 100%;\n  background-color: var(--base-0);\n  border-bottom: 1px solid var(--base-20);\n  box-shadow: var(--box-shadow-4);\n  z-index: 1;\n  padding-top: 4px;\n  padding-bottom: 4px;\n  padding-inline-start: 8px;\n  padding-inline-end: 24px;\n  box-sizing: border-box;\n  align-items: center;\n  justify-content: space-between;\n  position: relative;\n}\n\n.info {\n  display: flex;\n  align-items: center;\n  margin-inline-start: 8px;\n}\n\n.header-title {\n  font: var(--primary-font-family);\n  font-size: 20px;\n  font-weight: 700;\n  line-height: 24px;\n  letter-spacing: 0.15px;\n  color: var(--base-110);\n}\n\n.back {\n  margin-inline-end: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AllPinsHeader__container-ebcc7a`,
	"info": `AllPinsHeader__info-d4a9e0`,
	"header-title": `AllPinsHeader__header-title-b4daff`,
	"headerTitle": `AllPinsHeader__header-title-b4daff`,
	"back": `AllPinsHeader__back-e72cb7`
};
module.exports = ___CSS_LOADER_EXPORT___;
